module.exports = __webpack_public_path__ + "static/ionicons-dd4781d1acc57ba4c4808d1b44301201.ttf";